import { createContext, useContext } from 'react';
import * as React from 'react';
import type { BillingInfoType } from '@sdk/account/api/AccountApi';
import noop from '@sdk/utils/noop';

type BillingInfoContextType = {
  billingInfo: BillingInfoType;
  onBillingInfoUpdated?: (billingInfo: BillingInfoType) => void;
};

const BillingInfoContext = createContext<BillingInfoContextType>({
  billingInfo: null,
  onBillingInfoUpdated: noop,
});

const BillingInfoProvider: React.FC<React.PropsWithChildren<BillingInfoContextType>> = ({
  billingInfo,
  onBillingInfoUpdated = noop,
  children,
}) => {
  const value = {
    billingInfo,
    onBillingInfoUpdated,
  };

  return <BillingInfoContext.Provider value={value}>{children}</BillingInfoContext.Provider>;
};

function useBillingInfo(): BillingInfoContextType {
  const context = useContext(BillingInfoContext);
  if (!context) {
    throw new Error('BillingInfoContext must be used within a BillingInfoProvider');
  }

  return context;
}

export { BillingInfoProvider, useBillingInfo };
